<template>
  <div class="table-container">
    <el-table
      :data="tableData"
      border
      v-loading="loading"
      header-row-class-name="header"
      highlight-current-row
    >
      <el-table-column
        v-if="indexType"
        type="index"
        label="序号"
        width="55"
        :index="indexMethod"
        align="center"
      />
        <el-table-column
          v-for="(item, index) in headerList"
          :key="item.prop"
          :prop="item.prop"
          :label="item.label"
          :min-width="item.width ? item.width : ''"
          :fixed="item.fixed ? item.fixed : undefined"
        >
          <!-- 自定义表头 -->
          <template v-slot:header="scope">
            <div v-if="item.customHeader">
              <slot :name="item.customHeader"></slot>
            </div>
            <div v-else>{{ item.label }}</div>
          </template>
          <template v-slot:default="scope">
            <div v-if="item.customRender">
              <slot :name="item.customRender" :data="scope.row" />
            </div>
            <div v-else>{{scope.row[item.prop]}}</div>
          </template>
        </el-table-column>
    </el-table>
    <el-pagination
      v-if="total > 0"
      class="table-pagination"
      @current-change="handleCurrentChange"
      @size-change="handelSizeChange"
      :current-page="currentPage"
      :page-size="pageSize"
      :page-sizes="[10, 20, 30, 40]"
      :total="total"
      layout="total, sizes, prev, pager, next, jumper"
    />

  </div>
</template>

<script>
export default {
  name:'my-table',
  props:{
    loading:{
      type:Boolean,
      default:false
    },
    tableData:{
      type:Array,
      default:()=>[]
    },
    headerList:{
      type:Array,
      default:()=>[]
    },
    pageSize: {
      type: Number,
      default: 10
    },
    currentPage: {
      type: Number,
      default: 1
    },
    total: {
      type: Number,
      default: 0
    },
    indexType:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {

    }
  },
  methods: {
    handleCurrentChange(page) {
      this.$emit('currentPage-change', page);
    },
    // 分页数据变化
    handelSizeChange(val) {
      this.$emit('sizePage-change', val);
    },
    indexMethod(index) {
      return (
        index + 1 + (this.currentPage - 1) * this.pageSize
      );
    },
  }
}
</script>

<style scoped lang="less">
.table-container{
  margin-top: 15px;
}
.table-pagination{
  margin-bottom: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/my-table.vue